const styles = {
  container: {
    marginBottom: '40px'
  },
  info: {
    color: '#aaa',
    fontSize: '14px',
    '& info': {
      verticalAlign: 0
    }
  },
  title: {
    marginBottom: '10px',
    marginTop: '0'
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  topHeading: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  context: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  conclusion: {
    background: '#ebf9fe',
    padding: '8px 10px'
  },
  details: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    color: '#afafaf',
    overflow: 'hidden',
    '& li': {
      float: 'left',
      marginRight: '5px',
      '&:after': {
        content: '"•"',
        marginLeft: '5px'
      }
    },
    '& li:last-child:after': {
      content: '""'
    }
  },
  options: {
    marginTop: '18px',
    '& svg': {
      marginRight: '4px'
    }
  },
  uppercased: {
    '&:first-letter': {
      textTransform: 'uppercase'
    }
  }
}

export default styles
